import type { CSSProperties } from 'react';
import { C } from './theme';

/* ---- icons (raw inner svg) — ported from the prototype. Icons never emoji. ---- */
export const ICONS: Record<string, string> = {
  grid: '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  key: '<circle cx="15.5" cy="8.5" r="4"/><path d="M12.7 11.3 6 18l2 2 1.5-1.5"/>',
  ledger: '<rect x="4" y="3.5" width="16" height="17" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/>',
  doc: '<path d="M6 3.5h8l4 4V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1z"/><path d="M14 3.5V8h4"/>',
  wrench: '<path d="M15.5 4.5a4.5 4.5 0 0 0-5.9 5.7l-6 6L6 18.4l6-6a4.5 4.5 0 0 0 5.7-5.9l-2.6 2.6-2.2-.5-.5-2.2z"/>',
  bell: '<path d="M18 8a6 6 0 1 0-12 0c0 6-2.5 7-2.5 7h17S18 14 18 8z"/><path d="M10.5 20a2 2 0 0 0 3 0"/>',
  gear: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"/>',
  pin: '<path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  cal: '<rect x="3.5" y="4.5" width="17" height="16" rx="2"/><path d="M3.5 9h17M8 3v3M16 3v3"/>',
  chev: '<path d="M9 6l6 6-6 6"/>',
  home: '<path d="M4 11l8-6.5L20 11"/><path d="M6 9.5V20h12V9.5"/>',
  cam: '<rect x="3" y="6.5" width="18" height="13" rx="2.5"/><circle cx="12" cy="13" r="3.5"/><path d="M8.5 6.5l1.2-2h4.6l1.2 2"/>',
  rupee: '<path d="M7 4h10M7 8h10M15.5 4c0 4-3 6-6.5 6H7l7 10"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
  chat: '<path d="M20 12a8 8 0 0 1-11.5 7.2L4 20l.8-4.5A8 8 0 1 1 20 12z"/>',
  more: '<circle cx="5" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="19" cy="12" r="1.4"/>',
  phone: '<rect x="7" y="3" width="10" height="18" rx="2.5"/><path d="M11 18.5h2"/>',
  logout: '<path d="M15 4h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3"/><path d="M10 12H3M6 8l-3 4 3 4"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5 12 13l8.5-6.5"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2"/><path d="M6.5 7l.9 12.6a1 1 0 0 0 1 .9h7.2a1 1 0 0 0 1-.9L17.5 7"/><path d="M10.5 11v6M13.5 11v6"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
};

export function Icon({
  n,
  size = 18,
  color,
  style,
}: {
  n: string;
  size?: number;
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || 'currentColor'}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      dangerouslySetInnerHTML={{ __html: ICONS[n] ?? '' }}
    />
  );
}

/** The Aperture mark — Premise brand icon. */
export function Mark({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <rect x="4" y="4" width="112" height="112" rx="28" fill={C.accent} />
      <path
        d="M42 80 V50 a18 18 0 0 1 36 0 V80"
        fill="none"
        stroke="#fff"
        strokeWidth={11}
        strokeLinecap="round"
      />
      <rect x="33" y="84" width="54" height="8.5" rx="4.2" fill="#fff" />
    </svg>
  );
}
